module.exports = __webpack_public_path__ + "media/assets/dismiss-cross-e5bc2ea9.svg";